import { SET_HANDOFF } from '../../constants';

export const setHandoff = handoff => ({
  type: SET_HANDOFF,
  payload: !!handoff,
});
